import { render } from "./HelpCircleIcon.vue?vue&type=template&id=1023573a"
import script from "./HelpCircleIcon.vue?vue&type=script&lang=ts"
export * from "./HelpCircleIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script